"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dayjs = _interopRequireDefault(require("dayjs"));
var _utc = _interopRequireDefault(require("dayjs/plugin/utc"));
var _timezone = _interopRequireDefault(require("dayjs/plugin/timezone"));
var _duration = _interopRequireDefault(require("dayjs/plugin/duration"));
var _calendar = _interopRequireDefault(require("dayjs/plugin/calendar"));
var _isBetween = _interopRequireDefault(require("dayjs/plugin/isBetween"));
var _isSameOrAfter = _interopRequireDefault(require("dayjs/plugin/isSameOrAfter"));
var _isSameOrBefore = _interopRequireDefault(require("dayjs/plugin/isSameOrBefore"));
var _customParseFormat = _interopRequireDefault(require("dayjs/plugin/customParseFormat"));
_dayjs.default.extend(_utc.default);
_dayjs.default.extend(_calendar.default);
_dayjs.default.extend(_timezone.default);
_dayjs.default.extend(_duration.default);
_dayjs.default.extend(_isBetween.default);
_dayjs.default.extend(_customParseFormat.default);
_dayjs.default.extend(_isSameOrAfter.default);
_dayjs.default.extend(_isSameOrBefore.default);
var _default = exports.default = _dayjs.default;